/** Seata TX_XID header name (matches backend SeataConstants.TX_XID_HEADER). */
export const SEATA_TX_XID_HEADER = 'TX_XID';

/** Hyphenated alias — survives proxies that drop underscore headers. */
export const SEATA_TX_XID_ALT_HEADER = 'TX-XID';

/** Query param fallback (matches backend SeataConstants.TX_XID_PARAM). */
export const SEATA_TX_XID_PARAM = 'xid';

/** Wizard flow keys — one active flow drives TX_XID on fetchAPI. */
export const SEATA_WIZARD_FLOW = {
    FS_CREATE: 'fs-create',
    GL_CREATE: 'gl-create',
    WP_SAVE: 'wp-save',
} as const;

export type SeataWizardFlow = typeof SEATA_WIZARD_FLOW[keyof typeof SEATA_WIZARD_FLOW];

const txXidByFlow: Partial<Record<SeataWizardFlow, string>> = {};
let activeFlow: SeataWizardFlow | null = null;

export function setActiveSeataFlow(flow: SeataWizardFlow | null): void {
    activeFlow = flow;
}

export function getActiveSeataFlow(): SeataWizardFlow | null {
    return activeFlow;
}

export function setSeataTxXid(flow: SeataWizardFlow, xid: string | null): void {
    if (xid == null) {
        delete txXidByFlow[flow];
    } else {
        txXidByFlow[flow] = xid;
    }
}

export function getSeataTxXid(flow?: SeataWizardFlow | null): string | null {
    const key = flow ?? activeFlow;
    if (!key) return null;
    return txXidByFlow[key] ?? null;
}

export function clearSeataTxXid(flow: SeataWizardFlow): void {
    delete txXidByFlow[flow];
}

export function buildSeataTxHeaders(): Record<string, string> {
    const xid = getSeataTxXid();
    if (!xid) return {};
    return {
        [SEATA_TX_XID_HEADER]: xid,
        [SEATA_TX_XID_ALT_HEADER]: xid,
    };
}

/** Append xid query param when a wizard global transaction is active. */
export function appendSeataTxQuery(path: string): string {
    const xid = getSeataTxXid();
    if (!xid) return path;
    const separator = path.includes('?') ? '&' : '?';
    return `${path}${separator}${SEATA_TX_XID_PARAM}=${encodeURIComponent(xid)}`;
}
